// `console`, not the logger: the logger would join the polyfills chunk and the published CLI bundle. The warning
// fires once per isolate and only on a runtime whose native clock is broken.
/**
 * A probe Worker deployed on 2026-09-16 to the staging account, at compatibility dates 2026-07-08 and 2026-09-16 with
 * `nodejs_compat`, found no native `Temporal` in any of 14 isolates: this function returned true everywhere through its
 * first clause, and the polyfilled clock equalled `Date.now()` during requests. The epoch-zero clause guards a future
 * native `Temporal` whose clock is not wired to the virtualised clock. A working clock never reads exactly 0 during a
 * request, so 0 means broken and the polyfill must install over the native. `Date.now()` itself reads 0 at module scope
 * on the fleet, so a correctly wired native clock also reads 0 there; the clause then installs the polyfill over a
 * working native, which is safe.
 */
export function needsTemporalPolyfill(): boolean {
  if (typeof Temporal === 'undefined') {
    return true
  }
  try {
    if (Temporal.Now.instant().epochMilliseconds === 0) {
      // oxlint-disable-next-line no-console -- see the module comment
      console.warn('[polyfills] native Temporal clock reads epoch 0, installing the polyfill over it')
      return true
    }
    return false
  } catch (error) {
    // oxlint-disable-next-line no-console -- see the module comment
    console.warn('[polyfills] native Temporal clock read threw, installing the polyfill over it', String(error))
    return true
  }
}
